import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms'; // Import required modules
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-suppliars',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './suppliars.component.html',
  styleUrls: ['./suppliars.component.css'],
})
export class SuppliarsComponent implements OnInit {
  form: FormGroup;
  showTitleError = false;
  showFileError = false;

  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private toast: NgToastService
  ) {
    // Initialize the form group in the constructor
    this.form = this.fb.group({
      suppliarTitle: [''],
      suppliarDescription: ['', Validators.required],
      suppliarFile: [null],
    });
  }

  // File state
  uploadedFile: File | null = null;

  ngOnInit() {
    // Initialize form with form controls
    this.form = new FormGroup({
      suppliarTitle: new FormControl('', [Validators.required]),
      suppliarDescription: new FormControl('', [Validators.required]),
      suppliarFile: new FormControl([null]),
    });
  }

  // Handle file upload
  onFileUpload(event: any) {
    this.uploadedFile = event.target.files[0];
    console.log('Uploaded File: ', this.uploadedFile);

    if (this.uploadedFile) {
      // Make insuranceTitle required when a file is uploaded
      this.form.get('insuranceTitle')?.setValidators([Validators.required]);
      this.form.get('insuranceTitle')?.updateValueAndValidity(); // Trigger validation
    } else {
      // Remove required validator if no file is uploaded
      this.form.get('insuranceTitle')?.clearValidators();
      this.form.get('insuranceTitle')?.updateValueAndValidity(); // Trigger validation
    }
  }

  // Handle form submission
  onSubmit() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      // Form data
      const formData = this.form.value;

      // File data
      if (this.uploadedFile) {
        console.log('File to be uploaded:', this.uploadedFile);
      }
      const dataToSubmit = new FormData();
      dataToSubmit.append('name', formData.suppliarTitle);
      dataToSubmit.append('description', formData.suppliarDescription);

      dataToSubmit.append('project_id', '1');
      dataToSubmit.append('document_title', 'compliance document');
      dataToSubmit.append('document_type', 'document');
      dataToSubmit.append('document_user_doc_no', 'AAAA - 01');
      dataToSubmit.append('attach_documents', '1');
      dataToSubmit.append('document_status', 'draft');

      if (this.uploadedFile) {
        dataToSubmit.append('insuranceFile', this.uploadedFile);
        dataToSubmit.append('insuranceTitle', formData.insuranceTitle); // Title is required if file is uploaded
      }

      console.log('Form Data:', dataToSubmit);

      this.projectsService.addProjectSupplier(dataToSubmit).subscribe({
        next: (response: any) => {
          console.log('Project supplier added successfully:', response);
          this.toast.success(
            'Project supplier added successfully',
            'SUCCESS',
            4000
          );
          this.form.reset();
        },
        error: (error: any) => {
          console.error('Failed to add supplier of project:', error);
          this.toast.danger(
            'Failed to add supplier of project',
            'DANGER',
            4000
          ); // Show error toast
        },
      });
    } else {
      // Show error if file is uploaded but title is missing
      if (this.uploadedFile && !this.form.get('insuranceTitle')?.valid) {
        console.log('Title is required when a file is uploaded');
      }
    }
  }
}
